import { render, staticRenderFns } from "./VatSettings.vue?vue&type=template&id=27c8256a&"
import script from "./VatSettings.vue?vue&type=script&lang=js&"
export * from "./VatSettings.vue?vue&type=script&lang=js&"
import style0 from "./VatSettings.vue?vue&type=style&index=0&id=27c8256a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports